import React from 'react';
import SEO from './SEO';

const TermsAndConditions = () => {
  return (
    <>
      <SEO
        title="Terms & Conditions"
        description="Terms & Conditions for Lown - Understand the rules that govern using the Lown mortgage calculator and savings tools."
        keywords="terms and conditions, lown terms, app terms of use"
        url="https://www.lown.app/terms"
      />
      <div className="privacy-policy-page">
        <div className="privacy-policy-container animate-fade-in-up">
          <h1>Terms &amp; Conditions</h1>
          <p className="last-updated">Last updated: September 23, 2025</p>

          <section className="legal-section">
            <h2>Welcome to Lown</h2>
            <p>By using this app, you agree to these terms.</p>
          </section>

          <section className="legal-section">
            <h2>1. Not Financial Advice</h2>
            <p>
              Lown provides general tools and calculators to help you explore loans and savings. We do not
              provide financial, legal, or investment advice. You should consult a qualified professional
              before making financial decisions.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Use at Your Own Risk</h2>
            <ul>
              <li>
                While we strive for accuracy, we do not guarantee that calculations, forecasts, or
                recommendations are error-free.
              </li>
              <li>You are solely responsible for any actions taken based on information from the app.</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Accounts &amp; Sync Options</h2>
            <ul>
              <li>Lown lets you choose between a local-only profile or signing in with Apple to synchronize data.</li>
              <li>
                When you enable Apple Sign In, your loan, savings, and progress information is stored in your
                private iCloud account so it can stay consistent across your Apple devices.
              </li>
              <li>
                You are responsible for managing your Apple ID, iCloud storage, and security settings.
                Connectivity is required to keep devices in sync, but core calculators continue working offline.
              </li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Intellectual Property</h2>
            <p>
              All content, code, and design elements in Lown are the property of the app creators and may not be
              reproduced without permission.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Future Updates</h2>
            <p>
              These terms may change as we add new features (for example, cloud sync, additional integrations, or
              new export formats). We will post updates in-app and revise the &quot;Last updated&quot; date.
              Material changes will be communicated in-app.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Acceptable Use</h2>
            <ul>
              <li>Do not misuse the app (for example, attempting to reverse engineer or disrupt it).</li>
              <li>Do not upload unlawful, harmful, or infringing content.</li>
              <li>
                Use only iCloud accounts you own or control and do not attempt to access another user&apos;s synced
                data.
              </li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>7. Termination</h2>
            <p>
              We may suspend or terminate access if you violate these terms or use the app in a way that risks harm
              to others, the app, or our services.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Disclaimers &amp; Limitation of Liability</h2>
            <ul>
              <li>The app is provided &quot;as is&quot; without warranties of any kind, express or implied.</li>
              <li>
                To the maximum extent permitted by law, Lown and its creators shall not be liable for indirect,
                incidental, special, consequential, or punitive damages.
              </li>
              <li>
                Apple&apos;s iCloud service is provided by Apple; Lown is not responsible for outages, storage
                limits, or data loss attributable to Apple&apos;s systems.
              </li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>9. Governing Law</h2>
            <p>These terms are governed by the laws of the State of California, without regard to conflicts of law principles.</p>
          </section>

          <section className="legal-section">
            <h2>Contact Us</h2>
            <p>
              Questions about these terms? Email{' '}
              <a href="mailto:support@lown.app">support@lown.app</a>.
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default TermsAndConditions;
